import { BffWalletResponse } from '@lucky7ventures/bff-types';
import { Action } from 'redux';
import { BffApiErrorCode } from '@/models/bff-api-error';

export enum UserWalletActionType {
  GetUserWallet = 'GET_USER_WALLET',
  GetUserWalletSuccess = 'GET_USER_WALLET_SUCCESS',
  GetUserWalletError = 'GET_USER_WALLET_ERROR',
  IncrementDepositCount = 'INCREMENT_DEPOSIT_COUNT',
  ResetUserWallet = 'RESET_USER_WALLET',
}

export type GetUserWalletAction = Action<UserWalletActionType.GetUserWallet>;
export type GetUserWalletSuccessAction = Action<UserWalletActionType.GetUserWalletSuccess> & {
  wallet: BffWalletResponse;
};
export type GetUserWalletErrorAction = Action<UserWalletActionType.GetUserWalletError> & {
  error?: BffApiErrorCode;
};
export type IncrementDepositCountAction = Action<UserWalletActionType.IncrementDepositCount>;
export type ResetUserWalletAction = Action<UserWalletActionType.ResetUserWallet>;

export type UserWalletActions =
  | GetUserWalletAction
  | GetUserWalletErrorAction
  | GetUserWalletSuccessAction
  | IncrementDepositCountAction
  | ResetUserWalletAction;

export const getUserWallet = (): GetUserWalletAction => ({
  type: UserWalletActionType.GetUserWallet,
});

export const getUserWalletSuccess = (wallet: BffWalletResponse): GetUserWalletSuccessAction => {
  return {
    type: UserWalletActionType.GetUserWalletSuccess,
    wallet,
  };
};

export const getUserWalletError = (error: BffApiErrorCode): GetUserWalletErrorAction => ({
  type: UserWalletActionType.GetUserWalletError,
  error,
});

export const incrementUserDepositCount = () => ({
  type: UserWalletActionType.IncrementDepositCount,
});

export const resetUserWallet = () => ({
  type: UserWalletActionType.ResetUserWallet,
});
